import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'

import './styles/index.scss'

import App from './scripts/App'
import store from './redux/store'

import * as serviceWorker from './serviceWorker'

ReactDOM.render(
	<React.StrictMode>
		<Provider store={store}>
			<App />
		</Provider>
	</React.StrictMode>,
	document.getElementById('root')
)

serviceWorker.unregister()
// import index from './redux/index'